<script lang="ts">
	import Box from '$lib/components/boxes/Box.svelte';
	import { capitalize } from '$lib/utils/strings';
	import { t } from 'svelte-i18n';
	import { getTestimonies } from '@app/services/api/testimonies';
	import { onMount } from 'svelte';
	import type { TestimonyModel } from '@app/models/api/TestimoniesModel';
	import Quote from '$lib/components/Quote.svelte';
	import { getInitials, getShortName } from '@app/utils/user';
	import { urls } from '@app/urls';
	import { snackbar } from '$lib/stores/snackbar';
	import { page } from '$app/stores';
	import ButtonBoxPrimary from '../../../lib/elements/buttons/variants/ButtonBoxPrimary.svelte';

	export let operationId: string = null;

	let testimonies: TestimonyModel[];

	onMount(async () => {
		if ($page.data.user) {
			try {
				testimonies = (await getTestimonies(operationId)).data;
			} catch (e) {
				snackbar.danger($t('feedback.unavailable'));
			}
		}
	});
</script>

{#if testimonies && testimonies.length}
	<Box props={{ color: 'bg-dashboardBg', classNames: 'space-y-3' }}>
		<p class="font-semibold font-display text-2xl">{capitalize($t('operation.invested'))}</p>
		<Quote
			classNames="pb-4 border-b border-grey-lighter"
			name={getShortName(testimonies[0].firstName, testimonies[0].lastName)}
			initials={getInitials(testimonies[0].firstName, testimonies[0].lastName)}
			avatarUrl={testimonies[0].photo?.url}
			text={testimonies[0].text}
			date={testimonies[0].createdAt}
		/>
		<ButtonBoxPrimary
			props={{
				href: urls.PROJECT.TESTIMONIES(operationId),
				classNames: 'w-full inline-flex justify-center items-center',
				label: capitalize(
					$t('operation.testimoniesOverview', { values: { nbTestimonies: testimonies.length } })
				)
			}}
		/>
	</Box>
{/if}
